<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="TOC_Chapter-Title" id="uVOMdbqQ9cCunGD9VSINiqE"><a id="up8OQ2lFA5TyREx2Uwr3sM2"></a>Be A Tiny Bit Nicer Than You Have To Be</p>
<p class="Style-Group-1_Normal">OK, you aren’t being a dick. Badass. Next step? Push yourself to put a little more good into the world than you are required to by the situation present. Say please and thank you. Use markers of respect (ma’am, sir, or whatever is appropriate). Be kind. Tip extra. Hold the door open. Smile sympathetically at the parent with the screaming child. Be engaged, present, and just a little bit more awesome.</p>
<br/><p class="Style-Group-1_Normal">Recently, someone kept breaking into our neighborhood mailboxes (because some people haven’t read Rule Number One). This meant the mailman couldn’t leave our mail and it had to be brought back to the post office for pickup. My Boo saw his truck one day and asked him if we could get the mail from him and skip the drive. Mailman said, “I’m totally not supposed to do that, but for you I will. Your wife is always soooo nice to me.”</p>
<br/><p class="Style-Group-1_Normal">All I had ever done was to smile and wave when I saw the postman in the neighborhood (you know, like Mr. Rogers taught me to), thank him when he brought me packages, and if I saw him in front of the house, walk out to his truck so he didn’t have to get out. This is small, small stuff. And it’s stuff that most people just don’t do anymore. We aren’t talking about working in a soup kitchen every Saturday (though that is pretty badass, too). We are just talking about taking the time to recognize and respect other human beings on the planet.</p>
<br/><p class="Style-Group-1_Normal">Think about all the times someone being nice to you made your day bearable. Things that were pretty small for them were huge for you in that moment. We can put the same goodwill out into the world. Hell, even if it doesn’t work you totally earn serious karmic power-ups for trying harder than you have to.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// adulting3.vue?0b48092e